<template>
    <div class="list-dropdown no-spaces button-selection">
        <input type="checkbox" class="list-dropdown__trigger" id="facing-filter" :checked="isOpen" @click="toggle">
        <div class="list-dropdown__wrapper">
            <label class="list-dropdown__title" for="facing-filter">
                <span class="title">{{selected ? selected : 'Любая'}}</span>
            </label>
            <div class="list-dropdown__container" v-if="isOpen">
                <div class="list-dropdown__content">
                    <div class="list-dropdown__scroll">
                        <ul class="list-dropdown__select-list bigger" v-for="item in facings">
                            <li>
                                <button tabindex="0" type="button" @click="select(item)" :class="{'selected' : item == selected}">{{item}}</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="list-dropdown__bg"></div>
        </div>
    </div>
</template>

<script>
    // Data
    import facings from '../data/facings';

    export default {
        props: {
            value: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                facings: facings.map(x => x.title),
                selected: this.value,
                isOpen: false
            }         
        },
        watch: {
            value(newValue) {
                this.selected = newValue != 'Любая' ? newValue : null;
            },
            selected() {
                this.$emit("input", this.selected);
            }
        },
        methods: {
            select(facing) {
                this.selected = facing;
                this.isOpen = false;
            },
            toggle(e) {
                this.isOpen = !this.isOpen;
                const documentClickHandler = (e) => {
                    if (!e.target.closest('.list-dropdown') | e.target.closest('.list-dropdown') != this.$el) {
                        this.isOpen = false;
                        document.removeEventListener('click', documentClickHandler);
                    }
                }
                document.addEventListener('click', documentClickHandler);
            }
        }
    }
</script>